import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
     <ContextProvider>
      <App />
     </ContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);